class CartDrawer {

  constructor() {
    this.content = document.querySelectorAll('.cartblock');
    for (let i = 0; i < this.content.length; i ++) {
        this.content[i].addEventListener("mouseover", (event) => this.ChangeHeight(i));
    }
  }

  ChangeHeight(num) {
    this.content[1 - num].style.height = "20%";
    this.content[num].style.height = "80%";
  }

}

document.addEventListener('DOMContentLoaded', function() {
    new CartDrawer();
});